"use client";

/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * useAutoExpandNavigationSection
 *
 * Ensures a navigation section is expanded when a page is mounted.
 * Centralizes the auto-expand behavior used across dashboard landing pages.
 */

import { useEffect } from "react";

import { useNavigationStore } from "@/stores/navigation-store";

/**
 * Auto-expands the provided navigation section when the component mounts.
 * No-op if an invalid/empty section ID is provided.
 */
export function useAutoExpandNavigationSection(sectionId: string | null) {
  const { navigateToPage } = useNavigationStore();

  useEffect(() => {
    if (!sectionId) return;
    navigateToPage(sectionId);
  }, [navigateToPage, sectionId]);
}
